/**
 * Stock en vivo multitienda POSKN.
 */

let posknStockRefreshTimer = null;
let posknLastCatalogRev = 0;
let posknStockInflight = null;
let posknStockBackoffUntil = 0;
let posknStockFailStreak = 0;
let posknLastFullStockAt = 0;
let posknStockDegradedNotified = false;
let posknLastFocusRefresh = 0;

function posknResolvedDeferred(data) {
	const $ = window.jQuery;
	if ($ && $.Deferred) {
		return $.Deferred().resolve(data).promise();
	}
	return Promise.resolve(data);
}

function posknCollectVisibleProductIds() {
	const ids = [];
	document.querySelectorAll('.producto-card[data-product-id]').forEach((el) => {
		const id = parseInt(el.getAttribute('data-product-id'), 10);
		if (id > 0 && ids.indexOf(id) === -1) ids.push(id);
	});
	return ids;
}

function posknOnStockFail(err) {
	posknStockFailStreak += 1;
	if (posknStockFailStreak < 2) {
		console.warn('POSKN stock en vivo: reintento', err || '');
		return;
	}
	window._posknStockDegraded = true;
	const wait = Math.min(120000, 15000 * Math.pow(2, Math.min(posknStockFailStreak - 2, 3)));
	posknStockBackoffUntil = Date.now() + wait;
	if (!posknStockDegradedNotified && typeof window.mostrarNotificacion === 'function') {
		posknStockDegradedNotified = true;
		window.mostrarNotificacion(
			'El servidor no responde el stock en vivo. En sucursal se usa solo el inventario de esa tienda (no el de WooCommerce). Se reintentará solo.',
			'warning',
		);
	}
	console.warn('POSKN stock en vivo pausado', wait, err || '');
}

function posknResumeLiveStock() {
	posknStockFailStreak = 0;
	posknStockBackoffUntil = 0;
	posknStockDegradedNotified = false;
	window._posknStockDegraded = false;
	posknStockInflight = null;
	return posknRefrescarStockEnVivo({ force: true, full: true });
}

/** Tienda sucursal (id > 0). id 0 / null = stock WooCommerce principal. */
function posknUsaStockDeTienda() {
	const t = window.posknTiendaSeleccionada;
	if (!t) return false;
	const id = parseInt(t.id, 10);
	return !Number.isNaN(id) && id > 0;
}

function posknResolveManagingStock(product, variationId) {
	if (!product) return false;
	const vid = parseInt(variationId || 0, 10);
	if (vid > 0 && Array.isArray(product.variations)) {
		const v = product.variations.find((x) => x && parseInt(x.id, 10) === vid);
		if (v && v.managing_stock != null) return !!v.managing_stock;
	}
	return !!product.managing_stock;
}

function posknTiendaTieneStockRegistrado(baseProductId, variationId) {
	if (!posknUsaStockDeTienda()) return false;
	const stock = window.posknTiendaStock || {};
	const pid = parseInt(baseProductId || 0, 10);
	const vid = parseInt(variationId || 0, 10);
	const key = `${pid}-${vid}`;
	const parentKey = `${pid}-0`;
	return (
		Object.prototype.hasOwnProperty.call(stock, key) ||
		(vid > 0 && Object.prototype.hasOwnProperty.call(stock, parentKey))
	);
}

function posknRefreshVariableCardStock(productId) {
	const p = posknFindProductoEnData(productId);
	if (!p || !Array.isArray(p.variations)) return;
	const card = document.querySelector(`.producto-card[data-product-id="${productId}"]`);
	if (!card) return;
	let total = 0;
	let anyManaging = !!p.managing_stock;
	p.variations.forEach((v) => {
		if (v && v.managing_stock) {
			anyManaging = true;
			total += parseFloat(v.stock || 0);
		}
	});
	if (p.managing_stock) {
		card.setAttribute('data-managing-stock', '1');
		card.setAttribute('data-stock-global', p.stock != null ? p.stock : '');
	} else if (anyManaging) {
		card.setAttribute('data-managing-stock', '1');
		card.setAttribute('data-stock-global', String(total));
	} else {
		card.setAttribute('data-managing-stock', '0');
		card.removeAttribute('data-stock-global');
	}
}

function posknFindProductoEnData(productId) {
	const pid = parseInt(productId || 0, 10);
	const productosData = window.productosData;
	if (!pid || !Array.isArray(productosData)) return null;
	for (let i = 0; i < productosData.length; i++) {
		const cat = productosData[i];
		if (!cat || !Array.isArray(cat.products)) continue;
		for (let j = 0; j < cat.products.length; j++) {
			const p = cat.products[j];
			if (p && parseInt(p.id, 10) === pid) return p;
		}
	}
	return null;
}

function posknRememberWcStock(p) {
	if (!p || p._posknWcStockSaved) return;
	p._posknWcStockSaved = true;
	p._posknWcStock = p.stock;
	if (Array.isArray(p.variations)) {
		p.variations.forEach((v) => {
			if (v) v._posknWcStock = v.stock;
		});
	}
}

function posknRestoreWcStockOnCatalog() {
	if (!Array.isArray(window.productosData)) return;
	window.productosData.forEach((cat) => {
		if (!cat || !Array.isArray(cat.products)) return;
		cat.products.forEach((p) => {
			if (!p || !p._posknWcStockSaved) return;
			if (p._posknWcStock != null) p.stock = p._posknWcStock;
			if (Array.isArray(p.variations)) {
				p.variations.forEach((v) => {
					if (v && v._posknWcStock != null) v.stock = v._posknWcStock;
				});
			}
			const pid = parseInt(p.id, 10);
			if (pid) {
				posknRefreshVariableCardStock(pid);
				const card = document.querySelector(`.producto-card[data-product-id="${pid}"]`);
				if (card && p.managing_stock) {
					card.setAttribute('data-stock-global', p.stock != null ? String(p.stock) : '');
				}
			}
		});
	});
}

function posknOverlayProductosDataDesdeTienda() {
	if (!posknUsaStockDeTienda() || !Array.isArray(window.productosData)) return;
	const stock = window.posknTiendaStock || {};
	window.productosData.forEach((cat) => {
		if (!cat || !Array.isArray(cat.products)) return;
		cat.products.forEach((p) => {
			if (!p) return;
			posknRememberWcStock(p);
			const pid = parseInt(p.id, 10);
			if (!pid) return;
			if (Array.isArray(p.variations)) {
				p.variations.forEach((v) => {
					if (!v || !v.managing_stock) return;
					const vid = parseInt(v.id, 10);
					const key = `${pid}-${vid}`;
					if (Object.prototype.hasOwnProperty.call(stock, key)) v.stock = stock[key];
					else if (Object.prototype.hasOwnProperty.call(stock, `${pid}-0`)) v.stock = stock[`${pid}-0`];
					else v.stock = 0;
				});
			}
			if (!p.managing_stock) return;
			if (Object.prototype.hasOwnProperty.call(stock, `${pid}-0`)) {
				p.stock = stock[`${pid}-0`];
				return;
			}
			let total = 0;
			let any = false;
			Object.keys(stock).forEach((k) => {
				if (k.indexOf(`${pid}-`) === 0) {
					any = true;
					total += parseFloat(stock[k] || 0);
				}
			});
			p.stock = any ? total : 0;
		});
	});
}

function posknAplicarStockSnapshot(stockRows, opts) {
	opts = opts || {};
	if (!Array.isArray(stockRows)) return;
	if (posknUsaStockDeTienda()) {
		const tid = window.posknTiendaSeleccionada ? parseInt(window.posknTiendaSeleccionada.id, 10) : 0;
		const sameTienda = parseInt(window._posknTiendaStockId || 0, 10) === tid && !!window.posknTiendaStock;
		const replace = !!opts.replace || !sameTienda;
		const next = replace ? {} : Object.assign({}, window.posknTiendaStock);
		stockRows.forEach((s) => {
			const pid = parseInt(s.product_id, 10);
			const vid = parseInt(s.variation_id || 0, 10);
			next[`${pid}-${vid}`] = parseFloat(s.quantity || 0);
		});
		if (!replace && Array.isArray(opts.productIds) && opts.productIds.length) {
			const seen = {};
			stockRows.forEach((s) => {
				seen[parseInt(s.product_id, 10)] = true;
			});
			opts.productIds.forEach((raw) => {
				const pid = parseInt(raw, 10);
				if (pid <= 0 || seen[pid]) return;
				Object.keys(next).forEach((k) => {
					if (k === `${pid}-0` || k.indexOf(`${pid}-`) === 0) delete next[k];
				});
				next[`${pid}-0`] = 0;
			});
		}
		window.posknTiendaStock = next;
		window._posknTiendaStockId = tid;
		window._posknTiendaStockReady = true;
		posknOverlayProductosDataDesdeTienda();
	} else if (Array.isArray(window.productosData)) {
		window._posknTiendaStockReady = false;
		window.posknTiendaStock = {};
		window._posknTiendaStockId = 0;
		posknRestoreWcStockOnCatalog();
		stockRows.forEach((s) => {
			const pid = parseInt(s.product_id, 10);
			const vid = parseInt(s.variation_id || 0, 10);
			const qty = parseFloat(s.quantity || 0);
			window.productosData.forEach((cat) => {
				if (!cat || !Array.isArray(cat.products)) return;
				cat.products.forEach((p) => {
					if (!p || parseInt(p.id, 10) !== pid) return;
					posknRememberWcStock(p);
					if (vid === 0) {
						p.stock = qty;
						p._posknWcStock = qty;
						const card = document.querySelector(`.producto-card[data-product-id="${pid}"]`);
						if (card) card.setAttribute('data-stock-global', qty);
					} else if (Array.isArray(p.variations)) {
						p.variations.forEach((v) => {
							if (v && parseInt(v.id, 10) === vid) {
								v.stock = qty;
								v._posknWcStock = qty;
							}
						});
						posknRefreshVariableCardStock(pid);
					}
				});
			});
		});
	}
	if (typeof window.posknActualizarStockVisualProductos === 'function') {
		window.posknActualizarStockVisualProductos();
	}
	if (window.productoActual && window.productoActual.id) {
		const fresh = posknFindProductoEnData(window.productoActual.id);
		if (fresh) {
			window.productoActual.stock = fresh.stock;
			window.productoActual.variations = fresh.variations;
		}
	}
}

function posknDescontarStockDesdeItems(items) {
	if (!Array.isArray(items) || !items.length) return;
	items.forEach((item) => {
		if (item && item.enCocina) return;
		const baseId = parseInt(item.originalId || item.stockBaseId || item.id, 10);
		const varId = parseInt(item.stockVariationId || item.variacionId || 0, 10);
		const qty = parseFloat(item.cantidad || 0);
		if (baseId <= 0 || qty <= 0) return;
		if (item.is_composite_kn && !item.composite_deduct_parent) return;

		let managing =
			item.stockManaging != null
				? !!item.stockManaging
				: posknResolveManagingStock(posknFindProductoEnData(baseId), varId);
		if (!managing) return;

		if (posknUsaStockDeTienda()) {
			posknDescontarStockLocal(baseId, varId, qty);
			return;
		}

		const p = posknFindProductoEnData(baseId);
		if (varId > 0 && p && Array.isArray(p.variations)) {
			p.variations.forEach((v) => {
				if (v && parseInt(v.id, 10) === varId) {
					v.stock = Math.max(0, parseFloat(v.stock || 0) - qty);
					v._posknWcStock = v.stock;
				}
			});
			posknRefreshVariableCardStock(baseId);
		} else if (p && p.managing_stock) {
			p.stock = Math.max(0, parseFloat(p.stock || 0) - qty);
			p._posknWcStock = p.stock;
			const card = document.querySelector(`.producto-card[data-product-id="${baseId}"]`);
			if (card) card.setAttribute('data-stock-global', String(p.stock));
		} else {
			const card = document.querySelector(`.producto-card[data-product-id="${baseId}"]`);
			if (card && varId === 0) {
				const current = parseFloat(card.getAttribute('data-stock-global') || '0');
				card.setAttribute('data-stock-global', String(Math.max(0, current - qty)));
			}
		}
	});
	posknActualizarStockVisualProductos();
}

function posknRefrescarStockTrasPedido(source) {
	const list = Array.isArray(source) ? source : window.carrito || [];
	posknDescontarStockDesdeItems(list);

	const ids = [];
	list.forEach((item) => {
		const baseId = parseInt(item.originalId || item.stockBaseId || item.id, 10);
		if (baseId > 0 && !ids.includes(baseId)) ids.push(baseId);
	});

	const syncFromServer = () => {
		const req = ids.length ? posknRefrescarStockEnVivo({ productIds: ids }) : posknRefrescarStockEnVivo();
		if (req && typeof req.always === 'function') {
			req.always(() => posknActualizarStockVisualProductos());
		}
		return req;
	};

	return syncFromServer();
}

function posknRefrescarStockEnVivo(opts) {
	opts = opts || {};
	const now = Date.now();
	if (!opts.force && now < posknStockBackoffUntil) {
		return posknResolvedDeferred({ success: false, data: 'stock-backoff' });
	}
	if (
		!opts.force &&
		typeof window.posknIsOfflineMode === 'function' &&
		window.posknIsOfflineMode()
	) {
		return posknResolvedDeferred({ success: false, data: 'offline' });
	}
	if (posknStockInflight && !opts.force) {
		return posknStockInflight;
	}
	if (!window.POSKN || !window.POSKN.api || typeof window.POSKN.api.getStockLive !== 'function') {
		return posknResolvedDeferred({ success: false, data: 'no-api' });
	}

	const tiendaId =
		typeof opts.tiendaId !== 'undefined'
			? parseInt(opts.tiendaId, 10)
			: window.posknTiendaSeleccionada
				? parseInt(window.posknTiendaSeleccionada.id, 10)
				: 0;
	let productIds =
		opts.productIds && opts.productIds.length ? opts.productIds.map((id) => parseInt(id, 10)) : [];
	if (!productIds.length && !opts.full && now - posknLastFullStockAt < 90000) {
		const visible = posknCollectVisibleProductIds();
		productIds = visible.length > 40 ? [] : visible;
	}

	const req = window.POSKN.api.getStockLive(Number.isNaN(tiendaId) ? 0 : tiendaId, productIds, 12000);
	posknStockInflight = req;
	req
		.done((res) => {
			const currentTid = window.posknTiendaSeleccionada
				? parseInt(window.posknTiendaSeleccionada.id, 10) || 0
				: 0;
			const reqTid = Number.isNaN(tiendaId) ? 0 : tiendaId || 0;
			if (reqTid !== currentTid) {
				return;
			}
			if (res && res.success && res.data && Array.isArray(res.data.stock)) {
				posknStockFailStreak = 0;
				posknStockBackoffUntil = 0;
				window._posknStockDegraded = false;
				if (!productIds.length || opts.full) posknLastFullStockAt = Date.now();
				posknAplicarStockSnapshot(res.data.stock, {
					replace: !productIds.length || !!opts.full,
					productIds,
				});
				posknHandleCatalogSignals(res.data);
				return;
			}
			const status = res && res._httpStatus ? parseInt(res._httpStatus, 10) : 0;
			if (status >= 500 || (res && res._network)) {
				posknOnStockFail(res);
			}
		})
		.fail((err) => {
			posknOnStockFail(err);
		})
		.always(() => {
			if (posknStockInflight === req) posknStockInflight = null;
		});
	return req;
}

function posknHandleCatalogSignals(data) {
	data = data || {};
	const rev = parseInt(data.catalog_rev || 0, 10);
	const count = parseInt(data.product_count || 0, 10);
	if (!window._posknCatalogSeeded) {
		window._posknCatalogSeeded = true;
		posknLastCatalogRev = rev;
		window._posknLastProductCount = count;
		return;
	}
	const revChanged = rev > 0 && rev !== posknLastCatalogRev;
	const countChanged = count > 0 && count !== (parseInt(window._posknLastProductCount, 10) || 0);
	if (rev > 0) posknLastCatalogRev = rev;
	if (count > 0) window._posknLastProductCount = count;
	if ((revChanged || countChanged) && typeof window.posknSyncCatalogFromServer === 'function') {
		window.posknSyncCatalogFromServer();
	}
}

function posknHandleCatalogRev(revRaw) {
	posknHandleCatalogSignals({ catalog_rev: revRaw });
}

function posknProgramarRefrescoStockEnVivo() {
	if (posknStockRefreshTimer) clearInterval(posknStockRefreshTimer);
	posknStockRefreshTimer = setInterval(() => {
		if (document.visibilityState === 'visible') posknRefrescarStockEnVivo();
	}, 30000);
}

function posknGetStockTienda(productId, variationId) {
	if (!posknUsaStockDeTienda()) return null;
	const stock = window.posknTiendaStock || {};
	const key = `${productId}-${variationId || 0}`;
	if (Object.prototype.hasOwnProperty.call(stock, key)) return stock[key];
	const parentKey = `${productId}-0`;
	if ((variationId || 0) > 0 && Object.prototype.hasOwnProperty.call(stock, parentKey)) {
		return stock[parentKey];
	}
	return 0;
}

function posknCatalogStockQty(baseProductId, variationId) {
	const pid = parseInt(baseProductId || 0, 10);
	const vid = parseInt(variationId || 0, 10);
	if (pid <= 0) return 0;
	const p = posknFindProductoEnData(pid);
	if (p) {
		if (vid > 0 && Array.isArray(p.variations)) {
			const v = p.variations.find((x) => x && parseInt(x.id, 10) === vid);
			if (v && v.stock != null && v.stock !== '') return parseFloat(v.stock) || 0;
		}
		if (p.stock != null && p.stock !== '') return parseFloat(p.stock) || 0;
	}
	const card = document.querySelector(`.producto-card[data-product-id="${pid}"]`);
	if (card) {
		const g = card.getAttribute('data-stock-global');
		if (g !== null && g !== '') return parseFloat(g) || 0;
	}
	return 0;
}

function posknGetStockDisponible(baseProductId, variationId, fallbackStock, managingStock) {
	// Sin gestión de inventario → no limita la venta (ni con fila de tienda en 0).
	if (!managingStock) return null;
	if (posknUsaStockDeTienda()) {
		const stock = window.posknTiendaStock || {};
		const pid = parseInt(baseProductId || 0, 10);
		const vid = parseInt(variationId || 0, 10);
		const key = `${pid}-${vid}`;
		const parentKey = `${pid}-0`;
		if (Object.prototype.hasOwnProperty.call(stock, key)) {
			return parseFloat(stock[key]);
		}
		if (vid > 0 && Object.prototype.hasOwnProperty.call(stock, parentKey)) {
			return parseFloat(stock[parentKey]);
		}
		// Sucursal: sin fila en el snapshot = 0 (el servidor también cuenta 0).
		// Nunca usar el stock del catálogo WooCommerce (bodega / tienda principal).
		return 0;
	}
	if (fallbackStock == null || fallbackStock === '') {
		return posknCatalogStockQty(baseProductId, variationId);
	}
	return parseFloat(fallbackStock || 0);
}

/**
 * Revisa el carrito contra el snapshot de la sucursal antes de cobrar.
 * Evita meter en cola una venta que el servidor va a rechazar por stock.
 */
function posknValidarStockCarritoParaCobro(carrito) {
	const items = Array.isArray(carrito) ? carrito : [];
	// Tienda principal (id 0): el stock es WooCommerce. No aplicar el candado de sucursal.
	if (!posknUsaStockDeTienda()) {
		return { ok: true };
	}
	if (posknUsaStockDeTienda() && window._posknStockDegraded) {
		const snap = window.posknTiendaStock || {};
		const ready = !!window._posknTiendaStockReady && Object.keys(snap).length > 0;
		if (!ready) {
			return {
				ok: false,
				message:
					'Sin inventario de esta sucursal (el servidor no responde). No se puede cobrar hasta recuperar el stock de la tienda.',
			};
		}
	}

	const demand = {};
	const addDemand = (baseId, varId, qty, name, managing) => {
		if (!managing || baseId <= 0 || qty <= 0) return;
		const k = `${baseId}-${varId}`;
		if (!demand[k]) demand[k] = { baseId, varId, name, qty: 0 };
		demand[k].qty += qty;
	};

	items.forEach((item) => {
		if (!item) return;
		const qty = parseFloat(item.cantidad || 0);
		const skipParent = !!item.is_composite_kn && !item.composite_deduct_parent;
		if (!skipParent) {
			const baseId = parseInt(item.stockBaseId || item.originalId || item.id, 10);
			const varId = parseInt(item.stockVariationId || item.variacionId || 0, 10);
			const managing =
				item.stockManaging != null
					? !!item.stockManaging
					: posknResolveManagingStock(posknFindProductoEnData(baseId), varId);
			addDemand(baseId, varId, qty, item.name || `#${baseId}`, managing);
		}
		const groups = item.ckn && item.ckn.groups;
		if (!groups || typeof groups !== 'object') return;
		const consumeOpt = (idSel, optQty) => {
			const pid = parseInt(idSel, 10);
			if (pid <= 0 || optQty <= 0) return;
			const p = posknFindProductoEnData(pid);
			const snap = window.posknTiendaStock || {};
			const inSnap = posknUsaStockDeTienda() && Object.prototype.hasOwnProperty.call(snap, `${pid}-0`);
			const managing = p ? !!p.managing_stock : inSnap;
			if (!managing) return;
			addDemand(pid, 0, optQty * qty, (p && p.name) || item.name || `#${pid}`, true);
		};
		Object.keys(groups).forEach((gi) => {
			const sel = groups[gi];
			if (sel && typeof sel === 'object' && !Array.isArray(sel)) {
				Object.keys(sel).forEach((idSel) => consumeOpt(idSel, parseFloat(sel[idSel]) || 0));
			} else {
				(Array.isArray(sel) ? sel : [sel]).forEach((idSel) => consumeOpt(idSel, 1));
			}
		});
	});

	const shortages = [];
	Object.keys(demand).forEach((k) => {
		const d = demand[k];
		const avail = posknGetStockDisponible(d.baseId, d.varId, posknCatalogStockQty(d.baseId, d.varId), true);
		if (avail !== null && d.qty > parseFloat(avail) + 0.0001) {
			shortages.push(`${d.name} (disp. ${parseFloat(avail).toFixed(2)})`);
		}
	});
	if (shortages.length) {
		return {
			ok: false,
			message: `Stock insuficiente en esta sucursal: ${shortages.slice(0, 3).join(', ')}. El cobro no se envió a la cola.`,
		};
	}
	return { ok: true };
}

function posknCantidadEnCarrito(baseProductId, variationId, excludeIndex) {
	let total = 0;
	const carrito = window.carrito || [];
	const stock = window.posknTiendaStock || {};
	const usaStockPadre =
		posknUsaStockDeTienda() &&
		parseInt(variationId || 0, 10) > 0 &&
		Object.prototype.hasOwnProperty.call(stock, `${parseInt(baseProductId || 0, 10)}-0`);
	carrito.forEach((item, idx) => {
		if (excludeIndex !== undefined && idx === excludeIndex) return;
		const itemBaseId = parseInt(item.originalId || item.id || 0, 10);
		const itemVariationId = parseInt(item.variacionId || 0, 10);
		if (itemBaseId !== parseInt(baseProductId || 0, 10)) return;
		if (usaStockPadre) total += parseFloat(item.cantidad || 0);
		else if (itemVariationId === parseInt(variationId || 0, 10)) total += parseFloat(item.cantidad || 0);
	});
	return total;
}

function posknActualizarStockVisualProductos() {
	document.querySelectorAll('.producto-card').forEach((card) => {
		const label = card.querySelector('[data-stock-label]');
		if (!label) return;
		const productId = parseInt(card.getAttribute('data-product-id') || '0', 10);
		const productType = card.getAttribute('data-product-type') || 'simple';
		let managingStock = card.getAttribute('data-managing-stock') === '1';
		let stockGlobal = card.getAttribute('data-stock-global');
		if (productType === 'variable' && !posknUsaStockDeTienda()) {
			const p = posknFindProductoEnData(productId);
			if (p) {
				let total = 0;
				let anyVarManaging = !!p.managing_stock;
				if (Array.isArray(p.variations)) {
					p.variations.forEach((v) => {
						if (v && v.managing_stock) {
							anyVarManaging = true;
							total += parseFloat(v.stock || 0);
						}
					});
				}
				if (anyVarManaging && !p.managing_stock) {
					managingStock = true;
					stockGlobal = String(total);
				}
			}
		}
		if (posknUsaStockDeTienda()) {
			if (productType === 'variable') {
				const parentKey = `${productId}-0`;
				const stock = window.posknTiendaStock || {};
				let total = 0;
				if (Object.prototype.hasOwnProperty.call(stock, parentKey)) {
					total = parseFloat(stock[parentKey] || 0);
				} else {
					Object.keys(stock).forEach((key) => {
						if (key.indexOf(`${productId}-`) === 0) total += parseFloat(stock[key] || 0);
					});
				}
				label.textContent = `Stock tienda: ${total}`;
			} else {
				label.textContent = `Stock tienda: ${parseFloat(posknGetStockTienda(productId, 0) || 0)}`;
			}
		} else if (managingStock) {
			label.textContent = `Stock: ${stockGlobal !== '' ? stockGlobal : 0}`;
		} else {
			label.textContent = 'En stock';
		}
	});
}

function posknDescontarStockLocal(productId, variationId, cantidad) {
	const stock = window.posknTiendaStock || {};
	const key = `${productId}-${variationId || 0}`;
	if (Object.prototype.hasOwnProperty.call(stock, key)) {
		stock[key] = Math.max(0, stock[key] - cantidad);
	} else {
		const parentKey = `${productId}-0`;
		if ((variationId || 0) > 0 && Object.prototype.hasOwnProperty.call(stock, parentKey)) {
			stock[parentKey] = Math.max(0, stock[parentKey] - cantidad);
		}
	}
	window.posknTiendaStock = stock;
	posknOverlayProductosDataDesdeTienda();
	posknActualizarStockVisualProductos();
}

export function attachStockGlobals(win) {
	win.posknUsaStockDeTienda = posknUsaStockDeTienda;
	win.posknFindProductoEnData = posknFindProductoEnData;
	win.posknResolveManagingStock = posknResolveManagingStock;
	win.posknAplicarStockSnapshot = posknAplicarStockSnapshot;
	win.posknOverlayProductosDataDesdeTienda = posknOverlayProductosDataDesdeTienda;
	win.posknRefrescarStockEnVivo = posknRefrescarStockEnVivo;
	win.posknResumeLiveStock = posknResumeLiveStock;
	win.posknRefrescarStockTrasPedido = posknRefrescarStockTrasPedido;
	win.posknProgramarRefrescoStockEnVivo = posknProgramarRefrescoStockEnVivo;
	win.posknGetStockTienda = posknGetStockTienda;
	win.posknCatalogStockQty = posknCatalogStockQty;
	win.posknGetStockDisponible = posknGetStockDisponible;
	win.posknValidarStockCarritoParaCobro = posknValidarStockCarritoParaCobro;
	win.posknCantidadEnCarrito = posknCantidadEnCarrito;
	win.posknActualizarStockVisualProductos = posknActualizarStockVisualProductos;
	win.posknDescontarStockLocal = posknDescontarStockLocal;
	win.posknDescontarStockDesdeItems = posknDescontarStockDesdeItems;
	win.cargarStockTiendaPOS = (tiendaId) => {
		const tid = parseInt(tiendaId, 10) || 0;
		window.posknTiendaStock = {};
		window._posknTiendaStockReady = false;
		window._posknTiendaStockId = tid;
		if (tid <= 0) {
			posknRestoreWcStockOnCatalog();
			if (typeof window.posknActualizarStockVisualProductos === 'function') {
				window.posknActualizarStockVisualProductos();
			}
		}
		return posknRefrescarStockEnVivo({ tiendaId: tid, force: true, full: true });
	};
}

export function initStockLivePolling(win) {
	const refreshIfStale = () => {
		if (Date.now() - posknLastFocusRefresh < 20000) return;
		posknLastFocusRefresh = Date.now();
		posknRefrescarStockEnVivo();
	};
	document.addEventListener('visibilitychange', () => {
		if (document.visibilityState === 'visible') refreshIfStale();
	});
	win.addEventListener('focus', refreshIfStale);
	posknProgramarRefrescoStockEnVivo();
	win.setTimeout(() => posknRefrescarStockEnVivo({ full: true }), 800);

	const onStockBump = () => {
		try {
			if (win.posknCknCache) win.posknCknCache = {};
		} catch (e) {
			/* ignore */
		}
		posknRefrescarStockEnVivo();
	};

	win.addEventListener('storage', (ev) => {
		if (ev && ev.key === 'poskn_stock_bump') onStockBump();
	});

	try {
		if (typeof BroadcastChannel !== 'undefined') {
			const bc = new BroadcastChannel('poskn_stock');
			bc.onmessage = () => onStockBump();
			win._posknStockChannel = bc;
		}
	} catch (e) {
		/* ignore */
	}
}
